import { useState, useEffect } from 'react';

export const useDebouncedSearch = (value: string, delay: number = 500, minLength: number = 3): string => {
  const [debouncedValue, setDebouncedValue] = useState<string>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (value.length === 0 || value.length >= minLength) {
        setDebouncedValue(value);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, minLength]);

  return debouncedValue;
};
